import { CmsProduct } from '@hyphengroup/cms-components/types/cmsProduct';
export {
  ComponentTypeEnum,
  UserActionEnum,
} from '@hyphengroup/cms-components/utils/analytics/sendAnalytics';
import {
  ComponentTypeEnum,
  sendProductAnalytics as send,
  UserActionEnum,
} from '@hyphengroup/cms-components/utils/analytics/sendAnalytics';
import { pushDataLayer } from '../pushDataLayer';

export const sendProductAnalytics = (props: {
  event: string;
  action: UserActionEnum;
  componentType: ComponentTypeEnum;
  url?: string;
  componentTitle: string;
  product: CmsProduct;
  index: string;
}) => send({ ...props, pushDataLayer });
